module.exports = __webpack_public_path__ + "HowItWorks_Header_new.197466f3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/mobile/headers/HowItWorks_Header_new.png
// module id = PQ/s
// module chunks = 0